import backButton from '../../../../img/back_button.png'
import { useNavigate } from 'react-router-dom';


const BackButton = () => {
    const navigate = useNavigate();
    return (
        //<button onClick={() => window.history.back()}>戻る</button>
        <a  onClick={() => navigate("../user/photo-selection")} style={{display: 'flex', justifyContent: 'center'}}>
            <img src={backButton} alt='戻る' style={{ aspectRatio: '4 / 1', margin: '0px 0px 0px 0px', width: '100%' }} />
        </a>
    )
}

export default BackButton;
